import { Seo } from '../components/Seo';
import { buildTitle, SITE } from '../lib/site';
import { useI18n } from '../i18n';

export function TermsPage() {
  const { locale: t, fmt, formatDate } = useI18n();
  const p = t.pages.terms;
  const sub = { SITE: SITE.name, DOMAIN: SITE.domain };

  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.calloutText.replace(/\{SITE\}/g, SITE.name)}
        path="/terms"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{fmt(p.lead, { date: formatDate(new Date()) })}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="prose">
            <div className="callout">
              <div className="title">{p.calloutTitle}</div>
              <p>{fmt(p.calloutText, sub)}</p>
            </div>

            {p.sections.map((s, i) => (
              <div key={i}>
                <h2>{s.h}</h2>
                {s.p.map((para, j) => (
                  <p key={j}>{fmt(para, sub)}</p>
                ))}
                {s.ul && (
                  <ul>
                    {s.ul.map((li, j) => (
                      <li key={j}>{fmt(li, sub)}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
